var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.71 27.697c-3.978 0-7.215 3.237-7.215 7.215v21.103c0 3.981 3.364 7.345 7.345 7.345l24.315.146 5.103 9.52a1.684 1.684 0 0 0 1.677.883 1.685 1.685 0 0 0 1.444-1.224l2.577-9.179h4.304c3.978 0 7.215-3.237 7.215-7.215V35.055c0-3.978-3.236-7.215-7.215-7.215l-39.55-.143Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.976 49.2c1.392 0 2.592-1.152 2.592-2.64a2.58 2.58 0 0 0-2.592-2.592c-1.392 0-2.544 1.104-2.544 2.592s1.152 2.64 2.544 2.64Zm-10.416 0c1.392 0 2.592-1.152 2.592-2.64a2.58 2.58 0 0 0-2.592-2.592c-1.392 0-2.544 1.104-2.544 2.592s1.152 2.64 2.544 2.64Zm23.472-2.64c0 1.488-1.2 2.64-2.592 2.64-1.392 0-2.544-1.152-2.544-2.64 0-1.488 1.152-2.592 2.544-2.592a2.58 2.58 0 0 1 2.592 2.592Z",
  fill: "#F4CC54"
})));
export default SvgIcChat;